import SecondaryMenu from "../../components/layout/SecondaryMenu";
import ProbonosFields from "../../components/form/molecules/ProbonosFields";
import ContactFields from "../../components/form/molecules/ContactFields";
import Modal from "../../components/Modal";
import ImagePreview from "../../components/form/molecules/ImagePreview";

import {
  formattedDate,
  isoDate,
  deleteEmptyFields,
  validateEmail,
} from "../../globals";

import { MotifButton } from "@ey-xd/motif-react";

import { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Comments from "../../components/form/molecules/Comments";
import { fetchCountriesData, postProbonoData } from "../../services/api";
import LabelsContext from "../../context/LabelsContext";

import "../../assets/css/pages/new-activity.scss";
import InvalidModal from "../../components/InvalidModal";

const EditProbono = () => {
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [countryOptions, setCountryOptions] = useState([]);
  const [showInvalidModal, setShowInvalidModal] = useState(false);
  const [isDisabledButton, setIsDisabledButton] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [actionType, setActionType] = useState("");
  const location = useLocation();
  const probonoData = location.state?.probonoData || null;
  const labels = useContext(LabelsContext);
  const [formData, setFormData] = useState({
    title: probonoData?.title,
    subTitle: probonoData?.subTitle,
    description: probonoData?.description,
    startDate: formattedDate(probonoData.startDate),
    endDate: formattedDate(probonoData.endDate),
    investmentType: probonoData?.investmentType,
    moneyInvested: probonoData?.moneyInvested,
    engagement: probonoData?.engagement,
    contactName: probonoData?.contactName,
    contactEmail: probonoData?.contactEmail || "",
    fiscalYear: probonoData?.fiscalYear,
    team: probonoData?.team,
    comments: probonoData?.comments,
    isDraft: probonoData?.isDraft,
    country: probonoData?.country,
    probonusId: probonoData?.probonusId,
  });

  const [numericErrors, setNumericErrors] = useState({});
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCountriesData().then((data) => {
      const countries = Array.isArray(data)
        ? data.map((country) => ({
            value: country.countryName,
            label: country.countryName,
          }))
        : [];
      setCountryOptions(countries);
    });
  }, []);
  const handleNumericErrors = (errors) => {
    setNumericErrors(errors);
  };

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleFormSubmit = async (drafted) => {
    setisFormSubmited(true);
    if (isFormValid()) {
      setIsDisabledButton(true);
      const probonusId = formData.probonusId;

      const submitData = {
        ...formData,
        startDate: formData.startDate ? isoDate(formData.startDate) : null,
        endDate: formData.endDate ? isoDate(formData.endDate) : null,
        contact: {
          name: formData.contactName,
          email: formData.contactEmail,
        },
        probonusId,
        isDraft: drafted,
        comments: formData.comments === "<p><br></p>" ? "" : formData.comments
      };
      await postProbonoData(deleteEmptyFields(submitData));
      navigate("/actions/all-probonos");
      setIsDisabledButton(false);
    } else {
      setShowInvalidModal(true);
      setIsDisabledButton(false);
    }
  };

  const isFormValid = () => {
    const requiredFields = [
      "title",
      "description",
      "investmentType",
      "contactName",
      "contactEmail",
      "country",
    ];
    const newMissingFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field] || (field === 'description' && formData[field] === '<p><br></p>')) {
        newMissingFields.push(field);
      }
    });
    
    if (!validateEmail(formData.contactEmail)) {
      newMissingFields.push('contactEmail');
      setMissingFields(newMissingFields);
      return false;
    }
    const areDatesValid =
      formData.startDate instanceof Date &&
      !isNaN(formData.startDate) &&
      formData.endDate instanceof Date &&
      !isNaN(formData.endDate);
      if (!areDatesValid) {
        newMissingFields.push('startDate', 'endDate');
      }
    const hasNumericErrors = Object.values(numericErrors).some(
      (error) => error
    );
    setMissingFields(newMissingFields);
    return newMissingFields === 0 && areDatesValid && !hasNumericErrors;
  };

  const [isFormSubmited, setisFormSubmited] = useState(false);
  const navigate = useNavigate();

  const openWarningModal = () => {
    setActionType("save");
    setShowModal(true);
  };

  const closeWarningModal = () => {
    setShowModal(false);
  };

  const handleDiscardChanges = () => {
    window.scrollTo(0, 0);
    setShowModal(false);
    navigate("/activities/all-probonos");
  };

  const handleNavigateHome = () => {
    navigate("/actions/all-probonos");
  };
  const closeInvalidModal = () => {
    setShowModal(false);
    setShowInvalidModal(false);
  };
  const [fileQueue, setFileQueue] = useState([]);

  const handleCancelClick = () => {
    setActionType("cancel");
    setShowModal(true);
  };
  const handleEditClick = () => {
    setIsDisabled(!isDisabled);
    setIsEditing(!isEditing);
  };

  return (
    <>
      <SecondaryMenu
        title={labels.console_edit_probonos}
        onNavigate={handleNavigateHome}
        editing={isEditing}
        onEditClick={handleEditClick}
        sendFormDraft={() => handleFormSubmit(true)}
        pageType="probonos"
      />
      <section className="motif-col-lg-12 section-page">
        <ProbonosFields
          formData={formData}
          setFormData={setFormData}
          isFormSubmited={isFormSubmited}
          setFileQueue={setFileQueue}
          countryOptions={countryOptions}
          onNumericErrors={handleNumericErrors}
          isDisabled={isDisabled}
          fieldVisibility={{
            title: true,
            subTitle: true,
            description: true,
            investmentType: true,
            startDate: true,
            endDate: true,
            moneyInvested: true,
            engagement: true,
            fiscalYear: true,
            team: true,
            country: true,
          }}
        />

        <ContactFields
          onFieldChange={handleFieldChange}
          formData={formData}
          setFormData={setFormData}
          isFormSubmited={isFormSubmited}
          labels={labels}
          isDisabled={isDisabled}
          fieldVisibility={{
            rolOrg: false,
          }}
        />

        <Comments
          onFieldChange={handleFieldChange}
          formData={formData}
          setFormData={setFormData}
          isFormSubmited={isFormSubmited}
          required={false}
          isDisabled={isDisabled}
        />

        <div className="activity-buttons">
          <MotifButton
            variant="secondary"
            onClick={handleCancelClick}
            className="activity-buttons-secondary"
          >
            {labels.console_cancel}
          </MotifButton>
          <MotifButton
            onClick={openWarningModal}
            className="activity-buttons-primary"
            disabled={isDisabled}
          >
            {labels.console_save}
          </MotifButton>
        </div>
      </section>
      <section className="motif-col-lg-5">
        <ImagePreview imageQueue={fileQueue} />
      </section>

      <Modal
        show={showModal}
        onClose={closeWarningModal}
        title={
          actionType === "save"
            ? labels.console_changes_saved
            : labels.console_unsavedChanges
        }
        body={
          actionType === "save"
            ? labels.console_confirm_publish_probono
            : labels.console_leavePage
        }
        primaryButtonText={
          actionType === "save"
            ? labels.console_publish
            : labels.console_keepEditing
        }
        onPrimaryButtonClick={
          actionType === "save"
            ? () => handleFormSubmit(false)
            : closeWarningModal
        }
        secondaryButtonText={
          actionType === "save"
            ? labels.console_cancel
            : labels.console_discardChanges
        }
        onSecondaryButtonClick={handleDiscardChanges}
        disabled={isDisabledButton}
      />
      <InvalidModal
        show={showInvalidModal}
        onClose={closeInvalidModal}
        title={labels.console_title_invalidForm}
        body={labels.console_body_invalidForm}
        primaryButtonText={labels.console_close}
        onPrimaryButtonClick={closeInvalidModal}
        invalidFieldsMessage={missingFields.join(", ")}
      />
    </>
  );
};

export default EditProbono;
